// @flow
import React from 'react';
// Styles
import './LoggedInSkeleton.css';
// Assets
import userIcon from '../images/user.svg';

const LoggedInSkeleton = () => {
  return (
    <div className="logged-out-options-main">
      <div className="logged-out-container">
        <img
          src={userIcon}
          className="logged-out-container-img"
          alt="Ícone usuário"
        />
        <div className="user-indicator-skeleton-wrapper">
          <div className="user-indicator-skeleton user-indicator-skeleton-minor skeleton-block" />
          <div className="user-indicator-skeleton skeleton-block" />
        </div>
      </div>
    </div>
  );
};

export default LoggedInSkeleton;
